<template>
  <div id="app" class="app">
    <div v-if="shouldShowPasswordRenewalWarning && !isTechUser" class="password-alert-dismissable">
      <button @click="store.commit('SET_SHOULD_SHOW_PASSWORD_RENEWAL_WARNING', false)" class="close">×</button>
      {{$t('users.errors.password_expired')}}
      <label @click.prevent="handleOpenUpdatePasswordModal" class="update-link link">{{$t('users.errors.password_expired_update')}}</label>
    </div>
    <div v-if="needsRefresh" class="needs-refresh">
      <span v-text="$t('leads-web.alert_needs_refresh')"/>
      <div class="needs-refresh-close">
        <va-button @click="refresh" class="mr-4" v-text="$t('buttons.refresh')"/>
        <div @click="closeNotification" class="px-1 close-button">
          <va-icon name="fa fa-close" size="medium"></va-icon>
        </div>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import axios from "axios";
import SocketioService from "@/services/socketio.service.js";
import { mapState } from "vuex";
import store from "vuex-store";
import EventBus from "@/utils/EventBus";
import Vue from "vue";


export default {
  name: 'app',
  data() {
    return {
      needsRefresh: false
    }
  },
  async mounted() {
    console.dir(process.env.VUE_APP_ENVIRONMENT);
    if (process.env.VUE_APP_ENVIRONMENT !== 'prod' && process.env.VUE_APP_ENVIRONMENT !== 'demo') {
        console.dir(process.env)
    }
    if(process.env.VUE_APP_ENVIRONMENT !== 'local') {
      await this.checkNeedsRefresh()
      setInterval(async () => {
        await this.checkNeedsRefresh()
      }, 3600000)
    }
  },
  beforeDestroy() {
    SocketioService.disconnect()
  },
  methods: {
    async checkNeedsRefresh() {
      const file = await axios.get('/release_timestamp.txt', {
        transformRequest: (data, headers) => {
          delete headers.common['Authorization'];
          return data;
        }
      });

      if (file && file.data && process.env.VUE_APP_RELEASE_TIMESTAMP) {
        this.needsRefresh = file.data.toString().trim() !== process.env.VUE_APP_RELEASE_TIMESTAMP.toString().trim()
        this.moveNavBar()
      }
    },
    refresh(){
      location.reload(true)
    },
    closeNotification(){
      this.needsRefresh = false
      this.moveNavBar(false)
    },
    moveNavBar(isBottom = true){
      let navBar = this.$el.querySelector('#app nav.app-navbar')
      if(navBar){
        let size = isBottom ? '30px' : 0

        navBar.style.top = this.needsRefresh ? size : 0;

      }
    },
    handleOpenUpdatePasswordModal() {
      this.$router.push({ path: '/admin/profile' })
      Vue.nextTick(() => {
        EventBus.$emit('openChangePasswordModal')
      })

    }
  },
  computed: {
    store() {
      return store
    },
    ...mapState(['shouldShowPasswordRenewalWarning']),
    isTechUser() {
      return this.$auth.user().id === 1
    }
  }
}
</script>

<style lang="scss">
@import "../sass/main.scss";

body {
  height: 100%;
  background-color: $background-gray !important;

  #app {
    height: 100%;
  }
}

body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(117, 117, 117, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(117, 117, 117, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

body::-webkit-scrollbar {
  width: 12px;
  background-color: #F5F5F5;
}

body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: $evollu-dark;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(117, 117, 117, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(117, 117, 117, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb:horizontal {
  border-radius: 10px;
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: $evollu-dark;
}

.va-modal__inner::-webkit-scrollbar {
  width: 22px;
}

.va-modal__inner::-webkit-scrollbar-thumb {
  border: 6px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 14px;
  -webkit-border-radius: 14px;
  background-color: $evollu-dark;
}

.va-modal__inner::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

.va-modal__inner::-webkit-scrollbar-corner {
  background-color: transparent;
}

.needs-refresh{
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  height: 30px;
  top: 0;
  width: 100%;
  background: #ffd8d6;
  color: #f7776e;
  z-index: 10;
}

.needs-refresh-close{
  display: flex;
  position: absolute;
  align-items: center;
  right: 10px;
  height: 30px;
  > button{
    height: 24px;
    color: rgb(255, 255, 255);
    padding: 4px 20px !important;
  }
  > .close-button{
    cursor: pointer;
  }
}


.password-alert-dismissable {
  width: 380px;
  position: absolute;
  top: 70px;
  right: 25px;
  background-color: #ffeeba;
  color: #856404;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid transparent;
  z-index: 1000; /* Ensure it's above other elements */
}

.password-alert-dismissable .close {
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
}

.update-link {
  text-decoration: underline;
  cursor: pointer;
}

</style>
